import React, { useState, useEffect } from "react";
import _ from "lodash";
import { compose } from "redux";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Playing from "../bingo/screens/Playing";
import BingoCalled from "../bingo/screens/BingoCalled";
import Socket from "../../socket/socket";
import BadBingo from "../bingo/screens/BadBingo";
import * as gameAction from "../../redux/game/action";
import * as socketAction from "../../redux/sockets/action";

import HowToPlay from "././components/howToPlay/index";
import AllPlayersSideBar from "../bingo/screens/AllPlayersSideBar";
import BingoGameOver from "./screens/BingoGameOver";
import GetReady from "../bingo/screens/GetReady";
import backArrow from "../../assets/images/bingo/back-arrow.png";
import NextNumberModal from "../../pages/bingo/screens/NextNumberModal";
import BingoLobby from "../../components/bingo/index";

const Bingo = (props) => {
  const paramsReducerr = _.get(props, "paramsReducer.gameObj");
  const users = _.get(props, "gameReducer.roomObj.users");

  const room_obj = _.get(props, "gameReducer.roomObj");
  const gameTimer = room_obj?.game_state?.game_parameters?.timer;

  const [gamePaused, setgamePaused] = useState(false);
  const [showNumberModal, setshowNumberModal] = useState(false);
  const [allPlayers, setAllPlayers] = useState(false);
  const [countdown, set_countdown] = useState(gameTimer ? gameTimer : 10);

  const winnersArray = room_obj?.game_state?.winners;
  const timedGame = room_obj?.game_state?.game_parameters?.timed;
  const unCalledArray = room_obj?.game_state?.uncalled_numbers;
  const lastNumber = room_obj?.game_state?.previous_number;
  const badBingoArray = room_obj?.game_state?.bad_bingos;
  const bingoCalledArray = room_obj?.game_state?.called_bingo;
  const calledArray = room_obj?.game_state?.called_numbers;
  let how_to_play = props?.socketReducer?.howToPlay;
  let play_again = props?.socketReducer?.play_again;
  const volumeLevel = props?.socketReducer?.volume;

  const current_number = room_obj?.game_state?.current_number;
  const status = room_obj?.game_state?.status;
  const winnerUsers = users?.filter((userr) =>
    winnersArray?.includes(userr.player_id)
  );
  const bingoCalledUsers = users?.filter((userr) =>
    bingoCalledArray?.includes(userr.player_id)
  );
  const badBingoUsers = users?.filter((userr) =>
    badBingoArray?.includes(userr.player_id)
  );
  console.log(
    winnerUsers,
    winnersArray,
    "winnersArraywinnersArraywinnersArray"
  );
  let current_alphabet = "B";

  let output_array = unCalledArray
    ?.map((item) => {
      return { num: item, highlight: false };
    })
    .concat(
      calledArray.map((item) => {
        return { num: item, highlight: true };
      })
    )
    .sort((a, b) => a.num - b.num);

  output_array = output_array?.filter((item) => item.num !== 0);

  const toggleHowToPlay = () => {
    console.log(props, "props");
    props.toggleHowToPlay(!how_to_play);
  };

  const togglePlayAgain = () => {
    console.log(props, "props");
    props.togglePlayAgain(true);
  };

  // handle bingo sounds 
const playSoundsBingo = ()=>{
  let timer;
  if (countdown > 0) {
    timer =
      !gamePaused && setInterval(() => set_countdown(countdown - 1), 1000);
  } else if (countdown === 0) {
    console.log("timer", countdown);
    status !== "Over" && timedGame && onTimesUp();
  }
  return () => clearInterval(timer);


function currentAlp(num) {
  if (num < 16) {
    current_alphabet = "B";
  } else if (num >= 16 && num <= 30) {
    current_alphabet = "I";
  } else if (num >= 31 && num <= 45) {
    current_alphabet = "N";
  } else if (num >= 46 && num <= 60) {
    current_alphabet = "G";
  } else if (num > 60) {
    current_alphabet = "O";
  } else {
    current_alphabet = "";
  }
  return current_alphabet;
}}
  const on_play_again = () => {
    // props.setGameName("BNG");
    onTimesUp();
    props.history.push("/lobby");
    togglePlayAgain();
  };

  const toggleGamePaused = () => {
    if (gamePaused === false) {
      setgamePaused(true);
    } else {
      setgamePaused(false);
    }
  };
  const on_start_bingo = () => {
    props.setGameName("BNG");
    props.history.push("/lobby");
  };
  useEffect(() => {
    if (timedGame === false) {
      setgamePaused(true);
    }
  }, []);

  useEffect(() => {
    set_countdown(gameTimer);
  }, [current_number, status]);

  // useEffect(() => {
  //   if (current_number !== undefined) {
  //     setTimeout(() => {
  //       setshowNumberModal(false);
  //     }, 2000);
  //     setshowNumberModal(true);
  //   }
  // }, [current_number]);

  const onTimesUp = () => {
    const { socket } = props;
    let data = {
      action: "update-status",
      roomId: room_obj.id,
      tableTopName: "Bingo",
    };
    Socket.sendMessage(data);
  };

  useEffect(() => {
    let timer;
    if (countdown > 0) {
      timer =
        !gamePaused && setInterval(() => set_countdown(countdown - 1), 1000);
    } else if (countdown === 0) {
      console.log("timer", countdown);
      status !== "Over" && timedGame && onTimesUp();
    }
    return () => clearInterval(timer);
  }, [countdown, gamePaused, timedGame]);

  function currentAlphabet(num) {
    if (num < 16) {
      current_alphabet = "B";
    } else if (num >= 16 && num <= 30) {
      current_alphabet = "I";
    } else if (num >= 31 && num <= 45) {
      current_alphabet = "N";
    } else if (num >= 46 && num <= 60) {
      current_alphabet = "G";
    } else if (num > 60) {
      current_alphabet = "O";
    } else {
      current_alphabet = "";
    }
    return current_alphabet;
  }

  return (
    <>
      <div className="bingo-main">
        {<AllPlayersSideBar users={users} />}
        {how_to_play && (
          <HowToPlay
            toggleHowToPlay={toggleHowToPlay}
            paramsReducerr={paramsReducerr}
          />
        )}

        {status === "PrePlay" && (
          <GetReady
            toggleGamePaused={toggleGamePaused}
            countdown={countdown}
            gamePaused={gamePaused}
            paramsReducerr={paramsReducerr}
            onTimesUp={onTimesUp}
          />
        )}
        {(status === "Playing" ||
          status === "BadBingo" ||
          status === "BingoCalled" ||
          status === "Over") && (
          <Playing
            togglePlayAgain={togglePlayAgain}
            volumeLevel={volumeLevel}
            onTimesUp={onTimesUp}
            timedGame={timedGame}
            paramsReducerr={paramsReducerr}
            showNumberModal={showNumberModal}
            current_number={current_number}
            gamePaused={gamePaused}
            currentAlphabet={currentAlphabet}
            toggleGamePaused={toggleGamePaused}
            countdown={countdown}
            output_array={output_array}
            lastNumber={lastNumber}
          />
        )}
        {status === "BadBingo" && (
          <BadBingo
            current_number={current_number}
            onTimesUp={onTimesUp}
            gamePaused={gamePaused}
            timedGame={timedGame}
            paramsReducerr={paramsReducerr}
            countdown={countdown}
            toggleGamePaused={toggleGamePaused}
            currentAlphabet={currentAlphabet}
            lastNumber={lastNumber}
            badBingoUsers={badBingoUsers}
          />
        )}
        {status === "BingoCalled" && (
          <BingoCalled
            onTimesUp={onTimesUp}
            timedGame={timedGame}
            current_number={current_number}
            paramsReducerr={paramsReducerr}
            toggleGamePaused={toggleGamePaused}
            gamePaused={gamePaused}
            countdown={countdown}
            currentAlphabet={currentAlphabet}
            lastNumber={lastNumber}
            bingoCalledUsers={bingoCalledUsers}
          />
        )}
        {status === "Over" && (
          <BingoGameOver
            timedGame={timedGame}
            on_play_again={on_play_again}
            on_start_bingo={on_start_bingo}
            onTimesUp={onTimesUp}
            badBingoUsers={badBingoUsers}
            paramsReducerr={paramsReducerr}
            winnerUsers={winnerUsers}
          />
        )}
        {status === "joining" && <BingoLobby />}
      </div>
    </>
  );
};

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
  paramsReducer: state.paramsReducer,
  socketReducer: state.socketReducer,
});
const mapDispatchToProps = (dispatch) => {
  return {
    setGameName: (data) => dispatch(gameAction.setGameName(data)),
    toggleHowToPlay: (data) => dispatch(socketAction.toggleHowToPlay(data)),
    togglePlayAgain: (data) => dispatch(socketAction.togglePlayAgain(data)),
  };
};
export default compose(
  withRouter,
  connect(mapStateToProps, mapDispatchToProps)
)(Bingo);
